<app-ui *ngIf="sceneLoaded"></app-ui>
<div id="engine-wrapper" class="engine-wrapper">
  <canvas #rendererCanvas id="renderCanvas"></canvas>
</div>
